import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { BulkUploadEstampRoutingModule } from './bulk-upload-estamp-routing.module';
import { BulkUploadEstampParentComponent } from './bulk-upload-estamp-parent/bulk-upload-estamp-parent.component';
import { BulkUploadEstampStepComponent } from './bulk-upload-estamp-step/bulk-upload-estamp-step.component';
import { BulkUploadEstampComponent } from './bulk-upload-estamp/bulk-upload-estamp.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { BulkUploadExcelComponent } from './bulk-upload-excel/bulk-upload-excel.component';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';

@NgModule({
  declarations: [
    BulkUploadEstampParentComponent,
    BulkUploadEstampStepComponent,
    BulkUploadEstampComponent,
    BulkUploadExcelComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    DialogModule,
    BulkUploadEstampRoutingModule,
    ProgressBarModule,
    SharedComponentsModule,
  ],
})
export class BulkUploadEstampModule {}
